export default {
  detail(state) {
    const detail = _.cloneDeep(state.detail.data)
    return _.map(detail, (data) => {
      return data
    })
  },
  loading(state) {
    return state.detail.loading
  },
  topslide(state) {
    return state.topslide.list
  },
  topslideAll(state) {
    return state.topslide.all
  }
}
